import React, { useState, useMemo } from 'react'
import ContactMainView from '../components/Contacts/ContactMainView'
import ContactSidebar from '../components/Lead/Leadsideview'
import '../assets/css/Leads.css'
import EventEmitter from '../utils/EventEmitter'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { callLeadDetail } from '../redux/background/BackgroundAction'
import {
  ContactFetch,
  ContactCustomformFields,GetAsterCustommoduleData
} from '../redux/actions/ContactActions'
import { Decode } from '../utils/EncodeDecode'
function ContactView(props) {
  let Dispatch = useDispatch()
  let { phone_number, contact_id } = useParams()
  if(phone_number !== undefined){
    phone_number =Decode(phone_number)
  }
  const [name, setname] = useState()
  let state_value = useSelector((state) => state)
  const [create, setcreate] = useState(false)
  const [formData, setformData] = useState({})
  const [isthere, setisthere] = useState(false)
  const [formfield, setformfield] = useState([])




  useMemo(() => {

    mount()
  }, [phone_number])


  function fetchapi() {
    mount()
  }
  function mount() {
    Dispatch(ContactCustomformFields()).then(async(response) => {
      if(response.statusCode === 200){
      for (let i = 0; i < response.data[0].fields.length; i++) {
        const element = response.data[0].fields[i];
        if (element.catagory_value === "Custom module") {
          let url = `?template_name=${element.model}&skip=${0}&take=${0}&takeall=true`
          let payload = {
            url,
            bodydata:{
              template_name: element.model,
              fetch_type: 'internal',
            }
          }
         await  Dispatch(GetAsterCustommoduleData(payload)).then((res) => {
          if (res.statusCode === 200) {
              element.values = JSON.stringify(res.data.map((elm) => {
                return { name: elm.title, value: elm.title };
              }))

            }
          }).catch((err) => {
            console.log(err,"error in custom module fetch")
            EventEmitter.emit('error-message-getter', {
              action: 'fetch',
              module: 'Custom module data',
            })
          })
        }

      }
      setformfield(response.data[0])
      if (props.contactmodule) {
        setformData({ status: 204, data: "" })
        setcreate(true)
        setisthere(true)
        if (state_value.background.oncall === true && localStorage.getItem("dialpadname") === "") {
          localStorage.setItem("dialpadname", "Unknown Number");
          setname(localStorage.getItem("dialpadname"))
        }
      } else {
        Dispatch(
          ContactFetch( `/contact/fetchsearch?number=${phone_number}`,),
        ).then((res) => {
          if (res.statusCode  === 204) {
            res.statusCode = 204
            if (state_value.background.oncall === true && localStorage.getItem("dialpadname") === "") {
              localStorage.setItem("dialpadname", "Unknown Number");
              setname(localStorage.getItem("dialpadname"))
            }

            setcreate(true)
            setisthere(true)
            setformData(res)

          } else if (res.statusCode == 200) {
            if (state_value.background.oncall && state_value.background.oncalllead[0].render < 1 && state_value.background.socket_message.phonenumber.toString() === phone_number) {
              let leadData = {
                lead_id: res.data[0].id,
                lead_name: res.data[0].name,
                phone_number: res.data[0].phone_number,
                module: "contact",
                render: 1,
                list_id:0
              }
              Dispatch(callLeadDetail(leadData))
              let names = res.data[0].name
              if (names === "") {
                names = res.data[0].phone_number
              }
              localStorage.setItem("dialpadname", names);

              setname(localStorage.getItem("dialpadname"))
            }

            setisthere(true)
            let resdata={
              status:res.statusCode,
              data:{data:res.data,statusCode:res.statusCode}
            }
            setformData(resdata)
            setcreate(false)
          }
        }).catch((err) => {
          console.log(err,"error in contact fetch");
          EventEmitter.emit('error-message-getter', {
            action: 'fetch',
            module: "contact",
          })
        })
      }
    }
    }).catch((err) => {
      EventEmitter.emit('error-message-getter', {
        action: 'fetch',
        module: 'form fields',
      })
    })
  }

  return (
    <div className="page-main-container page-main-container-mobile">
      {isthere && (
        <>
          <div className="scroll-lft leads-lft">
            {create === false && (
              <div className="leads-sidebar">
                <ContactSidebar
                  formdatas={formData}
                  type={"contact"}
                  id={contact_id}
                />
              </div>
            )}
            <div
              className={
                create
                  ? 'leads-main leads-main-new'
                  : 'leads-main leads-main-exist'
              }
            >
              <ContactMainView
                fetchapi={fetchapi}
                operation={create}
                islead={props.islead}
                formdatas={formData}
                statedata={formfield}
                type={"ticket"}
              />
            </div>
          </div>

        </>
      )}
    </div>
  )
}

export default ContactView
